import type { Task } from '@/features/tasks/types';

export const TIME_TRACKER_OPEN_TASK_EVENT = 'netnet:time-tracker:open-task';

export type TimeTrackerOpenTaskDetail = {
  task: Task;
};

export function openTimeTrackerForTask(task: Task) {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(
    new CustomEvent<TimeTrackerOpenTaskDetail>(TIME_TRACKER_OPEN_TASK_EVENT, {
      detail: { task },
    }),
  );
}
